import type { RootState } from '../index';

// Get all messages
export const selectAllMessages = (state: RootState) => state.messages.messages;

// Get unread messages
export const selectUnreadMessages = (state: RootState) =>
  state.messages.messages.filter((message) => !message.isRead);

// Get read messages
export const selectReadMessages = (state: RootState) =>
  state.messages.messages.filter((message) => message.isRead);

// Get unread count
export const selectUnreadCount = (state: RootState) =>
  state.messages.messages.filter((message) => !message.isRead).length;

// Get total message count
export const selectTotalMessageCount = (state: RootState) => state.messages.messages.length;

// Get a specific message by id
export const selectMessageById = (state: RootState, messageId: string) =>
  state.messages.messages.find((message) => message.id === messageId);
